import openSocket from "socket.io-client";
import { urls } from "../constants/constants";
import Cookies from "universal-cookie";
// import { toast } from 'react-toastify';

class SocketService {
  constructor() {
    this.socket = null;
    this.io = null;
  }

  init() {
    if (!this.socket) {
      this.socket = openSocket(urls.aspariaBackend, {
        transports: ["websocket"],
        withCredentials: true,
      });

      this.socket.on("textchat", (msg) => {
        const receiveTextMessageFromSocket = new CustomEvent(
          "receiveTextMessageFromSocket",
          { detail: { msg, textChat: true } }
        );
        window.dispatchEvent(receiveTextMessageFromSocket);
      });

      this.socket.on("lcAgentReceiveMsg", (msg) => {
        const lcAgentReceiveMsg = new CustomEvent("lcAgentReceiveMsg", {
          detail: { msg, textChat: true },
        });
        window.dispatchEvent(lcAgentReceiveMsg);
      });

      this.socket.on("syncchat", (msg) => {
        const receiveTextMessageFromSocket = new CustomEvent(
          "receiveTextMessageFromSocket",
          { detail: { msg } }
        );
        window.dispatchEvent(receiveTextMessageFromSocket);
      });

      this.socket.on("syncLivechatAgentMsg", (msg) => {
        const lcAgentReceiveMsg = new CustomEvent("lcAgentReceiveMsg", {
          detail: { msg },
        });
        window.dispatchEvent(lcAgentReceiveMsg);
      });

      this.socket.on("synccount", () => {
        const syncPatientCount = new CustomEvent("syncPatientCount", {});
        window.dispatchEvent(syncPatientCount);
      });

      this.socket.on("syncLivechatAgentClientsCount", () => {
        const syncLivechatAgentClientsCount = new CustomEvent(
          "syncLivechatAgentClientsCount",
          {}
        );
        window.dispatchEvent(syncLivechatAgentClientsCount);
      });

      this.socket.on("syncNotification", () => {
        const syncNotificationCount = new CustomEvent(
          "syncNotificationCount",
          {}
        );
        window.dispatchEvent(syncNotificationCount);
      });

      this.socket.on("endSecureSession", (msg) => {
        const endSecureSession = new CustomEvent("endSecureSession", {
          detail: msg,
        });
        window.dispatchEvent(endSecureSession);
      });

      this.socket.on("linkNotClicked", (msg) => {
        const linkNotClicked = new CustomEvent("linkNotClicked", {
          detail: msg,
        });
        window.dispatchEvent(linkNotClicked);
      });

      this.socket.on("lcAgentNotificationBadge", (msg) => {
        const lcAgentNotificationBadge = new CustomEvent(
          "lcAgentNotificationBadge",
          {
            detail: { msg },
          }
        );
        window.dispatchEvent(lcAgentNotificationBadge);
      });

      this.socket.on("notificationAlert", (msg) => {
        const notificationAlert = new CustomEvent("notificationAlert", {
          detail: { msg },
        });
        window.dispatchEvent(notificationAlert);
      });

      this.socket.on("updatePatientReportStatus", (detail) => {
        const updatePatientReportStatus = new CustomEvent(
          "updatePatientReportStatus",
          { detail }
        );
        window.dispatchEvent(updatePatientReportStatus);
      });

      this.socket.on("updateBroadcastReportStatus", (detail) => {
        const updateBroadcastReportStatus = new CustomEvent(
          "updateBroadcastReportStatus",
          { detail }
        );
        window.dispatchEvent(updateBroadcastReportStatus);
      });

      this.socket.on("receiveMessageStatus", (msg) => {
        const updateSentMessageStatus = new CustomEvent(
          "updateSentMessageStatus",
          { detail: { msg } }
        );
        window.dispatchEvent(updateSentMessageStatus);
      });

      this.socket.on("docSignLinkStatus", (msg) => {
        const updateDocSignLinkStatus = new CustomEvent(
          "updateDocSignLinkStatus",
          { detail: { msg } }
        );
        window.dispatchEvent(updateDocSignLinkStatus);
      });
      if (!this.sendMessageHandler) {
        this.sendMessageHandler = (e) => {
          this.addSentMessageToState(e.detail);
        };
        window.addEventListener("sendMessage", this.sendMessageHandler, false);
      }
      if (!this.sendWebMessageHandler) {
        this.sendWebMessageHandler = (e) => {
          this.addSentWebMessageToState(e.detail);
        };
        window.addEventListener(
          "sendWebMessage",
          this.sendWebMessageHandler,
          false
        );
      }
      if (!this.lcAgentSendMessageHandler) {
        this.lcAgentSendMessageHandler = (e) => {
          this.addLiveAgentSentMessageToState(e.detail);
        };
        window.addEventListener(
          "lcAgentSendMessage",
          this.lcAgentSendMessageHandler,
          false
        );
      }
    }

    this.socket.on("socketError", (data) => {
      console.log(data.message);
    });
  }

  addSentMessageToState({ message, originalMessage }) {
    this.socket.emit("sendMessage", message, (data) => {
      const addSentMessageToState = new CustomEvent("addSentMessageToState", {
        detail: { data, originalMessage },
      });
      window.dispatchEvent(addSentMessageToState);
    });
  }

  addSentWebMessageToState({ message, originalMessage }) {
    this.socket.emit("sendWebMessage", message, (data) => {
      const addSentMessageToState = new CustomEvent("addSentMessageToState", {
        detail: { data, originalMessage },
      });
      window.dispatchEvent(addSentMessageToState);
    });
  }

  sendMessage(msg) {
    this.socket
      ? this.socket.emit("textchat", msg)
      : console.log("Socket not defined");
  }

  addLiveAgentSentMessageToState({ message }) {
    this.socket.emit("lcAgentSendMessage", message, (data) => {
      const addLiveAgentSentMessageToState = new CustomEvent(
        "addLiveAgentSentMessageToState",
        {
          detail: { data },
        }
      );
      window.dispatchEvent(addLiveAgentSentMessageToState);
    });
  }

  lcAgentSendMessage(msg) {
    this.socket
      ? this.socket.emit("textchat", msg)
      : console.log("Socket not defined");
  }

  disconnect() {
    // Remove window event listeners

    console.log("test delete event lister");
    if (this.sendMessageHandler) {
      window.removeEventListener("sendMessage", this.sendMessageHandler);
      this.sendMessageHandler = null;
    }
    if (this.sendWebMessageHandler) {
      window.removeEventListener("sendWebMessage", this.sendWebMessageHandler);
      this.sendWebMessageHandler = null;
    }
    if (this.lcAgentSendMessageHandler) {
      window.removeEventListener(
        "lcAgentSendMessage",
        this.lcAgentSendMessageHandler
      );
      this.lcAgentSendMessageHandler = null;
    }

    // Disconnect socket
    if (this.socket) {
      console.log("test delete inside socket");
      this.socket.disconnect();
      this.socket = null;
    }
  }
}

export default new SocketService();
